import { render, staticRenderFns } from "./logo.vue?vue&type=template&id=0716841d&"
import script from "./logo.js?vue&type=script&lang=js&"
export * from "./logo.js?vue&type=script&lang=js&"
import style0 from "./logo.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0716841d')) {
      api.createRecord('0716841d', component.options)
    } else {
      api.reload('0716841d', component.options)
    }
    module.hot.accept("./logo.vue?vue&type=template&id=0716841d&", function () {
      api.rerender('0716841d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/header/logo/logo.vue"
export default component.exports